import { UserRoles } from '@/enums';
import { all_roles } from '@/utils';
import cart_roles from './cart';
import clients_roles from './clients';
import organizations_roles from './organizations';
import products_roles from './products';
import staffs_roles from './staffs';
import leads_roles from './leads';
import user_roles from './user';
import subpartners_roles from './subpartners';
import orders_roles from './orders';
import main_page_roles from './main-page';
import companies_users_roles from './companies-users';
import repairs_roles from './repairs';
import dispatches_roles from './dispatches';
import marketing_fund from './marketing-fund';
import videos_roles from './videos';
import reports_roles from './reports';
import brand_portal_roles from './brand-portal';
import projects_sales_roles from './projects';
import courses_requests_roles from './courses-requests';
import news from './news';
import patchnotes from './patchnotes';
import marketing_materials from './marketing-materials';
import analytics from './analytics';
import software_licenses from './software-licenses';
import global_search from './global-search';
import conferences from './conferences';
import polls from './polls';
import contacts from './contacts';
import retro_bonuses from './retro-bonuses';
import commercial_offers from './commercial-offers';
import notifications from './notifications';
import calendar from './events-calendar';
import purchase_orders from './purchase-orders';
import data_pilot from './data-pilot';
import loans_roles from './loans';
import alfa_api_loan_applications_roles from './alfa-api-loan-applications';

export const RouteRoles = {
  ...cart_roles,
  ...clients_roles,
  ...organizations_roles,
  ...products_roles,
  ...staffs_roles,
  ...leads_roles,
  ...user_roles,
  ...subpartners_roles,
  ...orders_roles,
  ...main_page_roles,
  ...companies_users_roles,
  ...repairs_roles,
  ...dispatches_roles,
  ...marketing_fund,
  ...videos_roles,
  ...reports_roles,
  ...brand_portal_roles,
  ...projects_sales_roles,
  ...courses_requests_roles,
  ...news,
  ...patchnotes,
  ...marketing_materials,
  ...analytics,
  ...software_licenses,
  ...global_search,
  ...conferences,
  ...polls,
  ...contacts,
  ...retro_bonuses,
  ...commercial_offers,
  ...notifications,
  ...calendar,
  ...purchase_orders,
  ...data_pilot,
  ...loans_roles,
  ...alfa_api_loan_applications_roles,

  Заказы: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
  ],

  Взаиморасчёты: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],

  Проекты: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
  ],

  Лиды: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.SALE_MANAGER,
    UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
    UserRoles.Internal.MARKETER,
  ],

  'Заказ-наряды': [
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],

  'Заказ ЗИП': [
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],

  'Проверка гарантии': [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
  ],

  Обращения: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER,
    UserRoles.Internal.MARKETER,
  ],

  Баннеры: [
    UserRoles.External.IT_ADMIN,
    UserRoles.External.ADMIN,
  ],

  Рассылки: [
    UserRoles.External.IT_ADMIN,
    UserRoles.External.ADMIN,
  ],

  Новости: all_roles,
  'База знаний': all_roles,
  'Бренд портал': all_roles,
};
